<vp-flipclock *ngIf="date"
    [date]="date"
    [showSeconds]="showSeconds"
></vp-flipclock>